import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PackagesPage = lazy(() => import('../pages/packages/page'));
const SystemPage = lazy(() => import('../pages/system/page'));
const PsychologyPage = lazy(() => import('../pages/psychology/page'));
const MediaLabPage = lazy(() => import('../pages/medialab/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));

// Service Detail Pages
const EZKAStudyPage = lazy(() => import('../pages/services/ezka-study/page'));
const EZKACoachPage = lazy(() => import('../pages/services/ezka-coach/page'));
const EZKAClassPage = lazy(() => import('../pages/services/ezka-class/page'));
const EZKAPlusPage = lazy(() => import('../pages/services/ezka-plus/page'));
const EZKAPsyPage = lazy(() => import('../pages/services/ezka-psy/page'));
const EZKASeminarPage = lazy(() => import('../pages/services/ezka-seminar/page'));
const EZKACoffeePage = lazy(() => import('../pages/services/ezka-coffee/page'));
const EZKAAllStarPage = lazy(() => import('../pages/services/ezka-allstar/page'));
const EZKAMediaLabPage = lazy(() => import('../pages/services/ezka-medialab-detail/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/hizmetler/ezka-study',
    element: <EZKAStudyPage />,
  },
  {
    path: '/hizmetler/ezka-coach',
    element: <EZKACoachPage />,
  },
  {
    path: '/hizmetler/ezka-class',
    element: <EZKAClassPage />,
  },
  {
    path: '/hizmetler/ezka-plus',
    element: <EZKAPlusPage />,
  },
  {
    path: '/hizmetler/ezka-psy',
    element: <EZKAPsyPage />,
  },
  {
    path: '/hizmetler/ezka-seminar',
    element: <EZKASeminarPage />,
  },
  {
    path: '/hizmetler/ezka-coffee',
    element: <EZKACoffeePage />,
  },
  {
    path: '/hizmetler/ezka-allstar',
    element: <EZKAAllStarPage />,
  },
  {
    path: '/hizmetler/ezka-medialab',
    element: <EZKAMediaLabPage />,
  },
  {
    path: '/paketler',
    element: <PackagesPage />,
  },
  {
    path: '/sistem',
    element: <SystemPage />,
  },
  {
    path: '/psikoloji-kocluk',
    element: <PsychologyPage />,
  },
  {
    path: '/medialab',
    element: <MediaLabPage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/kvkk',
    element: <KVKKPage />,
  },
  {
    path: '/gizlilik-politikasi',
    element: <PrivacyPage />,
  },
  {
    path: '/cerez-politikasi',
    element: <CookiesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
